import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useLinePlanEntity as useLinePlanEntityAtom } from '~/atoms/hooks/useLinePlanEntity';
function normalizeLinePlanEntity(rawParam) {
    const raw = (rawParam || '').toString().toLowerCase();
    const singular = raw.endsWith('s') ? raw.slice(0, -1) : raw;
    const allowed = [
        'project',
        'product',
        'style',
        'expression',
        'model'
    ];
    return (allowed.includes(singular)
        ? singular
        : 'project');
}
export function useLinePlanEntity() {
    const { linePlanEntity, setLinePlanEntity } = useLinePlanEntityAtom();
    const params = useParams();
    useEffect(() => {
        const nextEntity = normalizeLinePlanEntity(params.linePlanEntity);
        if (linePlanEntity !== nextEntity)
            setLinePlanEntity(nextEntity);
    }, [params.linePlanEntity, linePlanEntity, setLinePlanEntity]);
    return { linePlanEntity, setLinePlanEntity };
}
